import * as React from 'react';
import { FilterContext } from './FilterContext';
import { Sticky } from 'react-sticky';
import cn from 'classnames';

const _styles = require('./HeaderFiltersBar.scss');

interface Props {
    renderHeaderElement: (key: string) => React.ReactNode | undefined;
}

export const HeaderFilterBar = (props: Props) => {
    const { availableFilters, setSelectedFilter, isSticky } = React.useContext(FilterContext);
    const inner = availableFilters.map((f) => (
        <span key={f} onClick={() => setSelectedFilter(f)}>
            {props.renderHeaderElement(f)}
        </span>
    ));
    return !isSticky ? (
        <div className={_styles.webFiltersButtons}>{inner}</div>
    ) : (
        <Sticky topOffset={48}>
            {({ style, isSticky }) => (
                <div className={cn(_styles.webFiltersButtons, { [_styles.stick]: isSticky })} style={style}>
                    {inner}
                </div>
            )}
        </Sticky>
    );
};
